import React from 'react';

import { WebPlayerActionContext } from './WebPlayerActionContext';

export const useWebPlayerActionsContext = () => React.useContext(WebPlayerActionContext);
